import { render, staticRenderFns } from "./StockViewReleaseProductStepRecap.vue?vue&type=template&id=e555e228&scoped=true"
import script from "./StockViewReleaseProductStepRecap.vue?vue&type=script&lang=js"
export * from "./StockViewReleaseProductStepRecap.vue?vue&type=script&lang=js"
import style0 from "./StockViewReleaseProductStepRecap.vue?vue&type=style&index=0&id=e555e228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e555e228",
  null
  
)

export default component.exports